
import { useNavigate } from 'react-router-dom';

const FeaturedContent = () => {
    const navigate = useNavigate();

    return (
        <section className="py-3">
            <div className="container text-center">
                <div className="row">
                    <h2 className="text-black font-bold text-uppercase">
                        FEATURED CONTENT
                    </h2>
                </div>
                <div className="row f-3 d-none">
                    <div className="col-auto">
                        <button
                            className="button-outline-small dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Filter 
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <button className="dropdown-item" type="button" onClick={() => navigate('/action')}>
                                    Action
                                </button>
                            </li>
                            <li>
                                <button className="dropdown-item" type="button" onClick={() => navigate('/another-action')}>
                                    Another action
                                </button>
                            </li>
                            <li>
                                <button className="dropdown-item" type="button" onClick={() => navigate('/something-else')}>
                                    Something else here
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeaturedContent;
